<template>
  <b-container class="base-container">
    <b-row>
      <b-col>
        <img
          class="profile-picture"
          v-if="member.file"
          :src="require('../../../assets/' + member.file)"
        />
        <p class="member-name">{{ member.name }}</p>
        <p class="member-title">{{ member.title }}</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    member: Object
  },
  computed: {},
  created() {}
};
</script>

<style scoped>
.base-container {
  height: 100%;
  width: 100%;
  box-shadow: 0px 0px 3px 1px #797979;
}
.member-name {
  margin-top: 60px;
  color: rgb(12, 192, 150);
  font-weight: bold;
}
.member-title {
  color: rgb(12, 192, 150);
}

.profile-picture {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  left: 0;
  margin: auto;
  top: -50px;
  box-shadow: 0px 0px 3px 1px #797979;
}
</style>
